import { RootState } from '@redux/types';

export const isNotPremiumModalOpenSelector = (state: RootState) => {
  return state.layout?.isNotPremiumModalOpen;
};

export const LayoutModeSelector = (state: RootState) => {
  return state.layout?.layoutMode;
};
